import axios from "axios";
import { BASE_API_URL } from "../constants/dropdown";

const getConfig = (getState) => {
  const { userInfo } = getState().admin2faLogin;
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${userInfo.token.access_token}`,
    },
  };
};

const buildQuery = (params) => {
  const q = Object.entries(params)
    .filter(([, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join("&");
  return q ? `?${q}` : "";
};

export const fetchBlacklist =
  (page = 1, limit = 50, searchText = "", includeRemoved = false) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: "GET_BLACKLIST_REQUEST" });
      const config = getConfig(getState);
      const query = buildQuery({ page, limit, searchText, includeRemoved });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/account-blacklist/all${query}`,
        config
      );
      dispatch({ type: "GET_BLACKLIST_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: "GET_BLACKLIST_FAIL",
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const addToBlacklist = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: "ADD_BLACKLIST_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/account-blacklist/add`,
      payload,
      config
    );
    dispatch({ type: "ADD_BLACKLIST_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "ADD_BLACKLIST_FAIL",
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const removeFromBlacklist = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: "REMOVE_BLACKLIST_REQUEST" });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/account-blacklist/remove`,
      payload,
      config
    );
    dispatch({ type: "REMOVE_BLACKLIST_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "REMOVE_BLACKLIST_FAIL",
      payload: error.response?.data?.message || error.message,
    });
  }
};
